<template lang="pug">
  .score(@click="$emit('toggleDebug')")
    .score-text: img(src="@/assets/images/game/status/image_score_text.png")
    .score-value(ref="value")
      p.score-value-number(
        v-for="num in scoreList"
        :class="`number-${num} number-sprite-${styleType}`"
      )
    .score-frame: img(src="@/assets/images/game/status/image_score_base.png")
</template>

<script>
import { TweenMax, Back } from 'gsap';
import { mapState, mapActions } from 'vuex';

import Utils from '@/assets/js/Utils';
import SoundController from '@/assets/js/SoundController';

export default {
  name: 'Score',
  data() {
    return {
      timer: null,
      scoreTimer: null,
      setScore: 0,
      beforeScore: 0,
      diffScore: 0,
      styleType: 's'
    };
  },
  computed: {
    ...mapState(['score']),
    changeScoreInterval: () => 50,
    scoreList() {
      return Utils.getNumberToList(this.setScore);
    }
  },
  watch: {
    score(val) {
      const diff = val - this.beforeScore;
      this.beforeScore = val;
      this.diffScore += diff;

      if (this.diffScore > 0 && this.scoreTimer === null) {
        this.scoreTimer = setTimeout(
          this.counter,
          this.changeScoreInterval + 250
        );
      }
    }
  },
  beforeDestroy() {
    SoundController.stopAll();
    if (this.timer) clearTimeout(this.timer);
    if (this.scoreTimer) clearTimeout(this.scoreTimer);
  },
  methods: {
    reset() {
      this.timer = null;
      this.scoreTimer = null;
      this.setScore = 0;
      this.beforeScore = 0;
      this.diffScore = 0;
      this.styleType = 's';
    },
    counter() {
      this.addAnimation();
      this.setScore++;
      this.diffScore--;
      if (this.diffScore > 0) {
        SoundController.play('se_add_score');
        setTimeout(this.counter, this.changeScoreInterval);
      } else {
        this.scoreTimer = null;
      }
    },
    addAnimation() {
      if (this.timer) clearTimeout(this.timer);
      this.styleType = 's-yellow';
      TweenMax.to(this.$refs.value, {
        scale: 1.5,
        duration: 0.25,
        ease: 'back.out(4)'
      });
      this.timer = setTimeout(() => {
        this.styleType = 's';
        TweenMax.to(this.$refs.value, { scale: 1, duration: 0.25 });
      }, 1000);
    }
  }
};
</script>

<style scoped lang="scss">
.score {
  position: absolute;
  top: vw(30);
  left: vw(30);
  z-index: 1;
  &-text {
    position: absolute;
    width: vw(246);
    top: vw(10);
    left: vw(164);
    z-index: 2;
  }
  &-value {
    display: flex;
    position: absolute;
    top: vw(80);
    right: vw(32);
    transform: rotate(-5deg);
    z-index: 1;
    &-number {
      margin-left: vw(-18);
      &:first-child {
        margin-left: 0;
      }
    }
  }
  &-frame {
    width: vw(490);
  }
  .number-sprite-s {
    background-image: image-url('game/number_s_spritesheet.png');
  }
  .number-sprite-s-yellow {
    background-image: image-url('game/number_s_spritesheet_yellow.png');
  }
}
</style>
